"use client";
import { useState, useEffect, useRef } from "react";

import "./Cta01.css";

import img from "./../../../img/cont/female-1.webp";
import Form01 from "./Form01";

function Cta01() {
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null);

  const handleFormClick = (e) => {
    e.preventDefault();
    setShowForm(true);
  };

  const handleClickOutside = (event) => {
    if (formRef.current && !formRef.current.contains(event.target)) {
      setShowForm(false);
    }
  };

  useEffect(() => {
    if (showForm) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [showForm]);

  return (
    <div className="Cta01 section" id="Cta01">
      <div className="container">
        <div className="Cta01-box">
          <div className="Cta01-text">
            <h2>Ready to Manage Your Waste Tyres Responsibly?</h2>
            <p>
              Join hundreds of businesses across the UK who trust Global Tyres
              Recycling Ltd. for compliant, efficient, and sustainable tyre
              recycling.
            </p>

            <a href="/" className="btn-1" onClick={handleFormClick}>
              GET IN TOUCH NOW
            </a>
          </div>

          <img src={img} alt="" />
        </div>
      </div>

      {showForm && (
        <div ref={formRef}>
          <Form01 />
        </div>
      )}
    </div>
  );
}

export default Cta01;
